import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import navContext from "../../../../Context/navContext";
import notifyContext from "../../../../Context/notifyContext";
import NumericLabel from "react-pretty-numbers";
import Loader from "../../../../Loader/Loader";
import { PARAMS_NUMBERS } from "../../../../../services/config";

import FormShare from "../FormShare/FormShare";
import {
  deleteOne,
  findAllByClient,
  save,
} from "../../../../../services/Share__Service";
import CardClient from "../../../../CardClient/CardClient";
import {
  MdClose,
  MdDelete,
  MdEdit,
  MdFolderOpen,
  MdWarning,
} from "react-icons/md";
import Modal from "../../../../Modal/Modal";
import Form from "../../Client/components/Form/Form";

const ListShare = () => {
  /* Handle Modal */
  const [viewClientId, setViewClientId] = useState(0);
  /* End Handle Modal */

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [idDelete, setIdDelete] = useState(0);
  const [closed, setClosed] = useState(null);
  const [isClosedLoading, setIsClosedLoading] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [editShare, setEditShare] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [shares, setShares] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [reload, setReload] = useState(false);

  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const redirect = useNavigate();

  const paramsRoute = useParams();

  useEffect(() => {
    if (reload) {
      setIsNew(false);
      setEditShare(null);
      setIsLoading(true);
      fetchAllShareByClient(paramsRoute.clientId);
    }
  }, [reload]);

  useEffect(() => {
    nav({
      links: [
        {
          href: "/main/client",
          linkname: "Clients",
        },
        {
          href: "",
          linkname: "Docs. Paie",
        },
      ],
      children: "",
    });
  }, []);

  useEffect(() => {
    fetchAllShareByClient(paramsRoute.clientId);
  }, []);

  const fetchAllShareByClient = async (id) => {
    findAllByClient(id)
      .then((response) => {
        setShares(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
        setReload(false);
      });
  };

  const handleEdit = React.useCallback(
    (share) => () => {
      setEditShare(share);
    },
    []
  );

  const handleClosed = React.useCallback(
    (share) => () => {
      setClosed(share);
    },
    []
  );

  const handleDelete = React.useCallback(
    (id) => () => {
      setIdDelete(id);
    },
    []
  );

  const handleSubmitDelete = () => {
    deleteOneShare(idDelete);
    setIdDelete(0);
  };

  const handleSubmitClosed = () => {
    closedShare({ ...closed, statut: 0 });
    setClosed(null);
    setIsClosedLoading(true);
  };

  const deleteOneShare = async (id) => {
    setIsDeleteLoading(true);
    return deleteOne(id)
      .then(() => {
        fetchAllShareByClient(paramsRoute.clientId);
        notify("Supprimé avec succès", "success");
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsDeleteLoading(false);
      });
  };

  const closedShare = async (doc) => {
    setIsClosedLoading(true);
    return save(doc)
      .then(() => {
        fetchAllShareByClient(paramsRoute.clientId);
        notify("Fermé avec succès", "success");
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsClosedLoading(false);
      });
  };

  const columns = useMemo(
    () => [
      {
        field: "Nom",
        headerName: "Nom",
        minWidth: 200,
        valueGetter: (params) => {
          return `${params.row.name}`;
        },
      },
      {
        field: "Commentaires",
        headerName: "Commentaires",
        minWidth: 200,
        valueGetter: (params) => {
          return params.row.countDetails;
        },
        renderCell: (params) => (
          <p style={{ cursor: "pointer" }}>
            <NumericLabel params={PARAMS_NUMBERS}>{params.value}</NumericLabel>
          </p>
        ),
      },
      {
        field: "Client",
        headerName: "Client",
        flex: 1,
        minWidth: 200,
        valueGetter: (params) => {
          return `${params.row.client.nom}`;
        },
        renderCell: (params) => (
          <p
            style={{ cursor: "pointer" }}
            onClick={() => setViewClientId(params.row.client.id)}
          >
            {params.value}
          </p>
        ),
      },

      {
        field: "Statut",
        headerName: "Statut",
        width: 120,
        valueGetter: (params) => {
          if (params.row.statut) return "Ouvert";
          else return "Fermé";
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdFolderOpen />}
            label="Ouvrir"
            onClick={() =>
              redirect(
                "/main/client/" +
                  paramsRoute.clientId +
                  "/share/" +
                  params.row.id +
                  "/details/"
              )
            }
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdEdit />}
            label="Renommer"
            onClick={handleEdit(params.row)}
            showInMenu
            disabled={!params.row.statut}
          />,
          <GridActionsCellItem
            icon={<MdClose />}
            label="Clôturer"
            onClick={handleClosed(params.row)}
            showInMenu
            disabled={!params.row.statut}
          />,

          // <GridActionsCellItem
          //   icon={<MdDelete />}
          //   label="Supprimer"
          //   onClick={handleDelete(params.id)}
          //   showInMenu
          //   disabled={!params.row.statut}
          // />,
        ],
      },
    ],
    [handleDelete, handleEdit, handleClosed]
  );

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <CardClient clientId={paramsRoute.clientId} />
      <button
        style={{
          width: "max-content",
          margin: "20px",
        }}
        className="btn"
        onClick={() => setIsNew(true)}
      >
        Nouveau partage
      </button>
      <div className="share__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={shares}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>

      {isDeleteLoading && <Loader loadingMsg="Suppression en cours" />}
      {idDelete !== 0 && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>Êtes-vous sûr (e) de vouloir supprimer ce bulletin ?</p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                Attention !!! Toutes les données de ce bulletin seront perdues.
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button className="btn btn--outline" onClick={handleSubmitDelete}>
                Oui
              </button>
              <button className="btn" onClick={() => setIdDelete(0)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}

      {isClosedLoading && <Loader loadingMsg="En cours d'envoi" />}
      {closed && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>Voulez-vous clôturer ce partage ?</p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                Attention !! Vous ne pourrez plus interagir avec ce partage.
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button className="btn btn--outline" onClick={handleSubmitClosed}>
                Oui
              </button>
              <button className="btn" onClick={() => setClosed(null)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}

      {viewClientId !== 0 && (
        <Modal>
          <div className={`modal ${viewClientId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Client</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewClientId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <Form clientId={viewClientId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewClientId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {isNew && (
        <Modal>
          <div className={`modal ${viewClientId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails du partage</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setIsNew(false)}
                >
                  X
                </button>
              </div>
              <div
                className="modal__body"
                style={{
                  padding: "20px",
                }}
              >
                <FormShare view={false} setReload={setReload} />
              </div>
            </div>
          </div>
        </Modal>
      )}

      {editShare && (
        <Modal>
          <div className={`modal ${viewClientId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails du partage</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setEditShare(null)}
                >
                  X
                </button>
              </div>
              <div
                className="modal__body"
                style={{
                  padding: "20px",
                }}
              >
                <FormShare
                  view={false}
                  shareId={editShare.id}
                  setReload={setReload}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}

      {isLoading && <Loader loadingMsg="Chargement..." />}
    </Fragment>
  );
};

export default ListShare;
